/**
 * Whether this browser holds a signed-in session, read without loading the auth
 * stack. authService keeps the signed-in user here (the session token itself is
 * an httpOnly cookie), so the key's presence is a cheap, local hint that the
 * visitor is worth loading the account layer for. Per origin: a custom domain
 * has its own.
 */
export const SESSION_USER_STORAGE_KEY = 'shader_chat_user';

export function hasStoredSession(): boolean {
  try {
    return localStorage.getItem(SESSION_USER_STORAGE_KEY) !== null;
  } catch {
    return false; // storage blocked: treat as a visitor
  }
}
